export default __webpack_public_path__ + "static/media/Certificate1 .8e73ffe8.png";